import { createAction } from '@mendeley-internal/lib-js-redux-actions';

const cite = (doc, style) => new Promise((resolve) => {
  require.ensure(['../../../client/js/services/citation'], require => (
    resolve(require('../../../client/js/services/citation').default(doc, style))
  ), 'citations');
});

export const getCitation = createAction(
  'GET_CITATION',
  ({ doc, style }) => cite(doc, style),
  ({ doc: { id }, style }) => ({ documentId: id, style })
);

export const copyToClipboard = createAction('COPY_TO_CLIPBOARD');



// WEBPACK FOOTER //
// ./src/universal/ui/actions/citation.js